import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {ScheduleService} from "../../_services/schedule.service";

declare var jQuery: any;
import * as $ from 'jquery';
import * as moment from 'moment';
import {Calendar} from '@fullcalendar/core';
import interaction from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";


@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {
  @Input() eventData: any[] = [];
  defaultConfigurations: any;
  userdetaild: any;

  addScheduleForm: FormGroup;
  editScheduleForm: FormGroup;
  submitted = false;
  submitted1 = false;

  day: string;
  date: string;
  start_time: string;
  end_time: string;
  getdaDte: string;
  duration: string = '60';
  preStart = '';
  preEnd = '';

  day1: string;
  date1: string;
  start_time1: string;
  end_time1: string;
  getdaDte1: string;
  sid: string;
  usersTypeList: any[] = ['admin','subadmin','supersubadmin','employee3'];
  adminUsers: any[] = ['admin','subadmin','supersubadmin'];

  @Input()
  set configurations(config: any) {
    if(config) {
      this.defaultConfigurations = config;
    }
  }

  id: string = this.route.snapshot.params['id'];
  userId: '';


  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private scheduleservice: ScheduleService,private spinnerService: Ng4LoadingSpinnerService) { }

  async ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    var startDate = moment().startOf('isoWeek');

    var endDate = moment().endOf('isoWeek');
    this.userId = this.userdetaild._id;
    // this.preStart = startDate.format('YYYY-MM-DD');
    // this.preEnd = endDate.format('YYYY-MM-DD');
    // if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
    //   this.router.navigate(['/']);
    // }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.addScheduleForm = this.formBuilder.group({
      location: ['Phone', [Validators.required]],
      scheduleFor: ['All', [Validators.required]],
      duration: ['60', [Validators.required]],
      status: ['true', [Validators.required]],
    });

    this.editScheduleForm = this.formBuilder.group({
      location: ['', [Validators.required]],
      scheduleFor: ['', [Validators.required]],

      status: ['', [Validators.required]],
    });

   
    this.route.queryParams.subscribe(params => {
      this.getdaDte = params['date'];
      if(this.getdaDte !== undefined){
        let prestart = moment(this.getdaDte).startOf('isoWeek');
        let preend = moment(this.getdaDte).endOf('isoWeek');
        this.preStart = prestart.format('YYYY-MM-DD');
        this.preEnd = preend.format('YYYY-MM-DD');
      }else{
        this.preStart = (params['preStart'])?params['preStart']:startDate.format('YYYY-MM-DD');
        this.preEnd = (params['preEnd'])?params['preEnd']:endDate.format('YYYY-MM-DD');
      }
      
    });

    await this.getDoctorSchedules(this.id, this.preStart, this.preEnd);
    // console.log(this.id);

    // this.loadCalender();

  }


  dayClick(info) {
    let tzDifference = info._d.getTimezoneOffset();
    let offsetTime = new Date(info._d.getTime() + tzDifference * 60 * 1000); //this will calculate time in point of view local time and set date
    let date = moment(offsetTime).format('YYYY-MM-DD');
    let start_time = moment(offsetTime).format('HH:mm');
    let myDate = moment(offsetTime).format('YYYY-MM-DD HH:mm:ss');
    let end_time = moment(myDate).add(1, 'hours').format('HH:mm');
    let day = moment(date).format('ddd');

    if (end_time == 'Invalid date'){
      let t = start_time.split(' ')[0];
      let t1 = t.split(':')[0];
      let t2 = parseInt(t1)+1;
      end_time = t2.toString()+":00";
      //console.log(end_date);
    }
    // console.log(day);
    this.day = day;
    this.date = date;
    this.start_time  = start_time;
    this.end_time  = end_time;
    jQuery('#addSchedule').modal('show');



  }

  async changeParam(payload){
    await this.getDoctorSchedules(payload);
    // this.loadCalender();
  }

  onOptionsSelected(e) {
    this.duration = e.target.value;
  }

  onSubmit(){

    this.submitted = true;
    //this.spinnerService.show();
    // stop here if form is invalid
    if (this.addScheduleForm.invalid) {
      //this.spinnerService.hide();
      return;
    }
    let finalEndTime;
    if (this.duration == '30') {
      let timeArray = [];
        let endTimeList = this.end_time.split(',');
        for (let item of endTimeList) {
          let dateTime = this.date+' '+item+':00';
          let myDate = moment(dateTime, 'YYYY-MM-DD HH:mm:ss');
            let new_end_time = moment(myDate).subtract(30, 'minutes').format('HH:mm');
            timeArray.push(new_end_time);
        }
        finalEndTime = timeArray.toString();
    }
    else{
      finalEndTime = this.end_time;
    }


    const payload = {
      docid: this.id,
      day: this.day,
      date: this.date,
      start_time: this.start_time,
      end_time: finalEndTime,
      location: this.addScheduleForm.controls.location.value,
      scheduleFor: this.addScheduleForm.controls.scheduleFor.value,
      status: this.addScheduleForm.controls.status.value,
      created_by: this.userId,
      updated_by: this.userId,
      timezone:  Intl.DateTimeFormat().resolvedOptions().timeZone,
      time_offset: new Date().getTimezoneOffset()
    };
    this.addEvent(payload,this.date);
  }

  onSubmitEdit(){

    this.submitted1 = true;
    //this.spinnerService.show();
    // stop here if form is invalid
    if (this.editScheduleForm.invalid) {
      //this.spinnerService.hide();
      return;
    }

    const payload = {
      id: this.sid,
      location: this.editScheduleForm.controls.location.value,
      scheduleFor: this.editScheduleForm.controls.scheduleFor.value,
      status: this.editScheduleForm.controls.status.value,
      timezone:  Intl.DateTimeFormat().resolvedOptions().timeZone,
      time_offset: new Date().getTimezoneOffset()
    };
    this.editEvent(payload,this.date1);
  }


  get f() { return this.addScheduleForm.controls; };
  get f1() { return this.editScheduleForm.controls; }

  addEvent(payload,date) {
    this.scheduleservice.createMultiSchedule(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            jQuery('#addSchedule').modal('hide');
            this.router.navigate([`/schedule/${this.id}`],{ queryParams: { date: date } });

          } else {
            this.toaster.showError('Add Schedule', data.ResponseMessage);
            //this.spinnerService.hide();
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Schedule', error.error.ResponseMessage);
          //this.spinnerService.hide();
        });
  }

  editEvent(payload,date) {
    this.scheduleservice.editEvent(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            jQuery('#editSchedule').modal('hide');
            this.router.navigate([`/schedule/${this.id}`],{ queryParams: { date: date } });

          } else {
            this.toaster.showError('Add Schedule', data.ResponseMessage);
            //this.spinnerService.hide();
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Schedule', error.error.ResponseMessage);
          //this.spinnerService.hide();
        });
  }

  deleteSchedule(id,date) {
    const payload = {id: id};
    this.scheduleservice.deleteSchedule(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            jQuery('#addSchedule').modal('hide');
            this.router.navigate([`/schedule/${this.id}`],{ queryParams: { date: date }});
            // this.route.params.subscribe(routeParams => {
            //   this.changeParam(routeParams.id);
            // });

            //location.reload();
          } else {
            this.toaster.showError('Schedule List', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Schedule List', error.error.ResponseMessage);
        });
  }


  async getDoctorSchedules(id: string, preStart?: string, preEnd?: string) {
    this.scheduleservice.getDoctorSchedules(id, preStart, preEnd)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {

            if (this.usersTypeList.includes(this.userdetaild['users_usertype']) == false) {
              let schData = data.avilibility;
              for (let item of schData) {
                // console.log(item);
                
                  if (item.slot_status == 'OPEN') {
                    let sch = {
                      _id: item._id,
                      title: item.title,
                      day: item.day,
                      location: item.location,
                      start: item.start,
                      end: item.end,
                      status: item.status,
                      slot_status: item.slot_status,
                      scheduleFor: item.scheduleFor,
                      patientName: item.patientName,
                      patientId: item.patientId,
                      isTransfered: item.isTransfered,
                      color: item.color,
                      allDay: item.allDay
                    };
                     this.eventData.push(sch);
                  }
                  if (item.slot_status == 'PROGRESS') {
                    let sch = {
                      _id: item._id,
                      title: item.title,
                      day: item.day,
                      location: item.location,
                      start: item.start,
                      end: item.end,
                      status: item.status,
                      slot_status: item.slot_status,
                      scheduleFor: item.scheduleFor,
                      patientName: item.patientName,
                      patientId: item.patientId,
                      isTransfered: item.isTransfered,
                      color: item.color,
                      allDay: item.allDay
                    };
                     this.eventData.push(sch);
                  }
                  if (item.slot_status == 'CLOSED') {
                    if (item.color == 'gray') {
                      let sch = {
                        _id: item._id,
                        title: item.title,
                        day: item.day,
                        location: item.location,
                        start: item.start,
                        end: item.end,
                        status: item.status,
                        slot_status: item.slot_status,
                        scheduleFor: item.scheduleFor,
                        patientName: item.patientName,
                        patientId: item.patientId,
                        isTransfered: item.isTransfered,
                        color: item.color,
                        allDay: item.allDay
                      };
                       this.eventData.push(sch);
                    }
                    else{
                        let sch = {
                          _id: item._id,
                          title: 'Booked',
                          day: item.day,
                          location: item.location,
                          start: item.start,
                          end: item.end,
                          status: item.status,
                          slot_status: item.slot_status,
                          scheduleFor: item.scheduleFor,
                          patientName: item.patientName,
                          patientId: item.patientId,
                          isTransfered: item.isTransfered,
                          color: item.color,
                          allDay: item.allDay
                        };
                         this.eventData.push(sch);
                    }

                  }
              }

            }else{
              this.eventData = data.avilibility;
              console.log(this.eventData);
              
            }
            this.loadCalender();
          }
          else{
            this.loadCalender();
          }
        },
        error => {
          this.loadCalender();
        });
  }

  addDefaultConfifurations(events,date){

    this.defaultConfigurations = {
      editable: false,
      eventLimit: true,
      plugins: [interaction, timeGridPlugin, dayGridPlugin],
      titleFormat: {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      },
      minTime: '00:00',
      maxTime: '23:59',
      customButtons: {
        myPrev: {
          text: 'Previous',
          click: () => {
            this.changeDate('pre');
          }
        },
        myNext: {
          text: 'Next',
          click: () => {
            this.changeDate('next');
          }
        },
        myToday: {
          text: 'Today',
          click: () => {
            this.changeDate('today');
          }
        }
      },
      header: {
        left: 'myPrev, myNext myToday',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      defaultView: 'timeGridWeek',
      // buttonText: {
      //   today: 'Today',
      //   month: 'Month',
      //   week: 'Week',
      //   day: 'Day'
      // },
      views: {
      },
      allDaySlot: false,
      allDayText: false,
      ignoreTimezone: false,
      timezone:Intl.DateTimeFormat().resolvedOptions().timeZone,
      slotDuration: '00:15:00',
      slotLabelInterval: '00:30:00',
      firstDay: 1,
      selectable: {
        month: false,
        agenda: true
      },
      datesRender: (info) => { 
        let view = info.view.props.dateProfile.activeRange;
        this.onRangeChange(view);
      },
     // selectHelper: true,
      events: events,

      // dayClick: (info) => {
      //   // this.datainfo = info;
      //
      //   this.dayClick(info);
      // },
      eventClick: (info) => {
        // console.log(info);
        
        if (this.usersTypeList.includes(this.userdetaild['users_usertype']) == false) {
          alert('You are not allowed');
        }else{
          let event = info.event,
            props = event.extendedProps;
          if (props.slot_status == 'OPEN'){
            this.openEdit(event, props);
          }
          if (props.slot_status == 'CLOSED'){
            if (props.patientId == '') {
              this.openEdit(event, props);
            }else{
              this.toaster.showError('Schedule','Cannot delete booked schedule');
            }
          }
          if (props.slot_status == 'PROGRESS'){
            if (this.adminUsers.includes(this.userdetaild['users_usertype'])) {
              this.openEdit(event, props);
            }else{
              this.toaster.showError('Schedule','Cannot edit progress Schedule');
            }
          }
        }

      },
      select: (info) => {
        if (this.usersTypeList.includes(this.userdetaild['users_usertype']) == false) {
          alert('You are not allowed');
        }else{
        let date = moment(info.start).format('YYYY-MM-DD');
        let day = moment(info.start).format('ddd');
        let start_time = moment(info.start).format('HH:mm');
        let end_time = moment(info.end).format('HH:mm');
        let start_time_for_diff = moment(info.start).format('YYYY-MM-DD HH:mm:ss');
        let end_time_for_diff = moment(info.end).format('YYYY-MM-DD HH:mm:ss');

        const differenceInMinutes = moment(end_time_for_diff).diff(start_time_for_diff, 'minutes');
        if (differenceInMinutes < 60){
          end_time = moment(start_time_for_diff).add(1, 'hours').format('HH:mm');
        }
        if (differenceInMinutes > 60){
          end_time = moment(end_time_for_diff).add(30, 'minutes').format('HH:mm');
        }

        let timeStops = this.getTimeStops(start_time, end_time);
        // console.log(timeStops);
        let start_array = [];
        let end_array = [];

        let i;
        for (i = 0; i <= timeStops.length; i = i + 1) {
          if (timeStops[i] !== undefined && timeStops[i+1] !== undefined) {
            start_array.push(timeStops[i]);
            end_array.push(timeStops[i + 1]);
          }
        }

        this.day = day;
        this.date = date;
        this.start_time  = start_array.toString();
        this.end_time  = end_array.toString();
        jQuery('#addSchedule').modal('show');
      }
      }

    };
  }

  getTimeStops(start, end){
    let startTime = moment(start, 'HH:mm');
    let endTime = moment(end, 'HH:mm');

    if( endTime.isBefore(startTime) ){
      endTime.add(1, 'day');
    }

    let timeStops = [];

    while(startTime <= endTime){
      timeStops.push(moment(startTime).format('HH:mm'));
      startTime.add(1, 'hours');
    }
    return timeStops;
  }

  openEdit(info, props) {
    let date = moment(info.start).format('YYYY-MM-DD');
    let start = moment(info.start).format('HH:mm');
    let end = moment(info.end).format('HH:mm');

    this.sid = props._id;
    this.day1 = props.day;
    this.date1 = date;
    this.start_time1  = start;
    this.end_time1  = end;

    this.editScheduleForm.setValue({
      location: props.location,
      scheduleFor: (props.scheduleFor)?props.scheduleFor:"All",
      status: props.status
    })

    jQuery('#editSchedule').modal('show');
  }


 loadCalender(){
    this.route.params.subscribe(routeParams => {
      this.addDefaultConfifurations(this.eventData,this.getdaDte);
      let calendar = new Calendar(
        document.getElementById('full-calendar'),
        this.defaultConfigurations
      );
      calendar.render();
      calendar.gotoDate(this.preStart);
      // calendar.changeView(timeGridPlugin, obj)
       
     
    });
  }

  async onRangeChange(dates){
    // let start = moment(dates.start).format('YYYY-MM-DD');
    // let end = moment(dates.end).format('YYYY-MM-DD');
    // this.preStart = start;
    // this.preEnd = end; 
    // console.log(this.preStart);
    // console.log(this.preEnd);
    
  }

  changeDate(forr){
    if(forr == 'pre'){
      console.log(this.preStart);
      console.log(this.preEnd);
     let prestart = moment(this.preStart).subtract(1, 'weeks').startOf('isoWeek');
     let preend = moment(this.preStart).subtract(1, 'weeks').endOf('isoWeek');
     this.preStart = prestart.format('YYYY-MM-DD');
     this.preEnd = preend.format('YYYY-MM-DD');
    }
    if(forr == 'next'){
      let nxtstart = moment(this.preStart).add(1, 'weeks').startOf('isoWeek');
     let nxtend = moment(this.preStart).add(1, 'weeks').endOf('isoWeek');
     this.preStart = nxtstart.format('YYYY-MM-DD');
     this.preEnd = nxtend.format('YYYY-MM-DD');
    }
    if(forr == 'today'){
      this.preStart = '';
      this.preEnd = '';
    }
    let url = this.router.url.split('?')[0];
    if(this.preStart !== ''){
      this.router.navigate([`${url}`],{queryParams: {preStart: this.preStart, preEnd: this.preEnd}});
    }
    else{
      this.router.navigate([`${url}`]);
    }
    
  
  }

}
